import { MessageEnvelope } from '../../schema/message';

export const TIMETOKEN_MULTIPLIER = 10_000;

export const getMessageDisplayTimetoken = (message: MessageEnvelope): number =>
  Number(message.displayTimetoken ?? message.timetoken);

export const getMessageDayKey = (message: MessageEnvelope): string => {
  const ms = getMessageDisplayTimetoken(message) / TIMETOKEN_MULTIPLIER;
  const date = new Date(ms);
  const midnightMs = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  ).getTime();

  return String(midnightMs * TIMETOKEN_MULTIPLIER);
};
